export default __webpack_public_path__ + "assets/44febe65fe77da810796195778d3e138.png";